#encryption-content {
  #encryption-info-text {
    color: var(--body-text-arrows-400);
  }
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.section {
  margin-top: calc(var(--spacer) * 4);
}

gz-form-field {
  &#tpm-form-field {
    margin-left: calc(var(--spacer) * 3.5);
  }
}

.helper-text {
  padding-top: calc(var(--spacer) * 0.5);
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
}

.checkbox-subtitle {
  --label-font-size: calc(11px + var(--dynamic-small-font-size-changer));
  --label-font-family: var(--font-family);
  margin-top: 2px;
}
